import React from "react";

const NotificationsSenior = (props) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 -4 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.827254 16.3132C0.560362 16.3132 0.320703 16.1606 0.211767 15.921C0.102832 15.6813 0.140959 15.3981 0.30981 15.1966C1.7641 13.4863 2.52121 10.9971 2.56478 7.81072C2.56478 4.35745 5.56596 1.57959 9.25344 1.57959C13.2841 1.57959 15.8876 4.03064 15.8876 7.81616C15.8876 11.3021 17.0532 13.9111 18.1426 15.1966C18.3169 15.3981 18.355 15.6813 18.2406 15.921C18.1263 16.1606 17.8866 16.3132 17.6252 16.3132H0.827254ZM2.15627 14.9515H16.3125C15.3538 13.3229 14.5259 10.85 14.5259 7.81072C14.5259 4.21584 11.8025 2.93584 9.25344 2.93584C6.31762 2.93584 3.92648 5.10366 3.92648 7.76169V7.82161C3.88835 10.7139 3.29465 13.105 2.16172 14.9515H2.15627Z"
        fill={props.color}
        stroke={props.color}
        stroke-width="0.3"
      />
      <path
        d="M9.24807 19.9998C10.7296 19.9998 11.9115 18.9159 11.9115 17.5215H6.54102C6.54102 18.9159 7.72297 19.9998 9.24807 19.9998Z"
        fill={props.color}
      />
      <path
        d="M10.5551 2.25497V1.24187C10.5551 0.582806 9.96138 0 9.24241 0C8.47985 0 7.8916 0.582806 7.8916 1.24187V2.25497H10.5551Z"
        fill={props.color}
      />
      {props.badge && (
        <>
          <circle cx="13" cy="2" r="6" fill="#FF3B30" />
          <text
            x="13"
            y="2"
            textAnchor="middle"
            dominantBaseline="central"
            fill="white"
            fontSize="8"
            fontWeight="bold"
          >
            1
          </text>
        </>
      )}
    </svg>
  );
};

export default NotificationsSenior;
